import { DetailedHTMLProps, HTMLAttributes, ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import { NEXT_ID, PORTAL_ID } from '@/constants/common'

interface PortalProps extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {
  children: ReactNode
}

function Portal({ id = PORTAL_ID, children }: PortalProps) {
  const [container, setContainer] = useState<HTMLElement | null>(null)

  useEffect(() => {
    let el = document.getElementById(id)

    if (!el) {
      const nextContainer = document.getElementById(NEXT_ID)
      el = document.createElement('div')
      el.id = id

      if (nextContainer) {
        nextContainer.appendChild(el)
      }
      else if (document.body) {
        document.body.appendChild(el)
      }
    }

    setContainer(el)
  }, [id])

  return container ? createPortal(children, container) : null
}

export default Portal
